// @core/api/endpoints/calendar/delete_event_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/calendar';

/**
 * Delete event template
 * Deletes an event template. Events created from this template are not affected.
 */
export async function DeleteEventTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/event-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
